import React, { useEffect, useState } from "react";

const WhatsAppShareButton = () => {
  const [isCordovaAvailable, setIsCordovaAvailable] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const message =
    "🥦🍎 Yaasaai Veg & Fruit App is Now Live on Google Play! 🛒 Order fresh veggies and fruits directly from your local shops.📍 Track orders, get updates, and enjoy great offers! Download Now: https://play.google.com/store/apps/details?id=com.yaasaai.myApp";

  useEffect(() => {
    const handleDeviceReady = () => {
      if (window.plugins?.socialsharing) {
        setIsCordovaAvailable(true);
      }
    };

    document.addEventListener("deviceready", handleDeviceReady);

    return () => {
      document.removeEventListener("deviceready", handleDeviceReady);
    };
  }, []);

  const handleShare = () => {
    if (isCordovaAvailable) {
      // Use Cordova plugin
      window.plugins.socialsharing.shareViaWhatsApp(
        message,
        null,
        null,
        () => console.log("Shared successfully via plugin"),
        (err) => alert("WhatsApp not available: " + err)
      );
    } else {
      // Fallback for browser
      const whatsappWebUrl = `https://wa.me/?text=${encodeURIComponent(
        message
      )}`;
      window.open(whatsappWebUrl, "_blank");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <button
        onClick={handleShare}
        style={{
          backgroundColor: "#25D366",
          color: "#fff",
          padding: "10px 16px",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          position: "relative",
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          style={{ width: "24px", height: "24px" }}
        />
      </button>

      {showTooltip && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "110%",
            transform: "translateY(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: "4px",
            whiteSpace: "nowrap",
            fontSize: "14px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          }}
        >
          Share on WhatsApp
        </div>
      )}
    </div>
  );
};

export default WhatsAppShareButton;
